<template>
  <div class='key-value-select'>
    <el-select
      @change="changeValue"
      :class="className"
      :value="currentValue"
      @input="(value)=>{input(value)}"
      :placeholder="cpPlaceHolder"
      :filterable="openSearch"
      :remote="openSearch && !localSearch"
      :reserve-keyword="openSearch && !localSearch"
      :remote-method="remoteMethod"
      :loading="loading"
      :disabled="disabled"
      clearable
    >
      <el-option v-if="isNeedAll && !openSearch" label="全部" :value="allValue"></el-option>
      <el-option
        v-for="(item, index) in dictDataList"
        :key="index"
        :value="item.value"
        :label="item.label"
      ></el-option>
    </el-select>
    <span class="delete-button" @click="clearData" v-if="openSearch && value !== ''"><i class="el-icon-circle-close"></i></span>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { isEqual } from "lodash"
import md5 from "js-md5"
import { getDictData } from "@/api/keyValue/keyValue";
import { setStore, getStore, removeStore } from "@/utils/store";
export default {
  props: {
    circleItem: {
      type: Object,
      default: () => {}
    },
    // 绑定值
    value: {},
    // 是否开启搜索
    openSearch: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 重置搜索
    resetSearch: {
      type: Boolean,
      default: false
    },
    // 是否需要 全部选项
    isNeedAll: {
      type: Boolean,
      default: false
    },
    // 全部选项的参数
    allValue: {
      type: String,
      default: ""
    },
    // 字典请求url
    dictUrl: {
      type: String
    },
    dictParam: {
      type: Object,
      default: () => {}
    },
    // 数据映射关系
    dictProp: {
      type: Object,
      default: function() {
        return {
          data: "result",
          label: "dictValue",
          value: "dictKey"
        };
      }
    },
    // select class name
    className: {
      type: String
    },
    // 占位说明
    placeholder: {
      type: String,
      default: "请选择"
    },
    // 请求方式
    methods: {
      type: String,
      default: "get"
    },
    apiForm:{
        type:String,
        default:'1'
    },
    // 默认搜索 传入后台参数
    searchParam: {
      type: String,
      default: "deptName"
    },
    // key映射的值 在search启用的时候，如果该值不为空，会默认作为搜索参数进行一次搜索
    labelValue: {
      type: String,
      default: ""
    },
    // 用于监听数据变化手动更改下拉项
    dynamicValue: {
      type: Number,
      default: 0
    },
    // 用于监听数据变化手动更改下拉项
    changeShow: {
      type: Boolean,
      default: true
    },
    // 是否需要缓存
    isNeedCash: {
      type: Boolean,
      default: true
    },
    // 是否在传入值没有对应字典的时候清空传入值
    cleanIfNoMatch: {
      type: Boolean,
      default: false
    },
    // 传入参数后自动搜索一次
    autoSearch: {
      type: Boolean,
      default: false
    },
    // 本地搜索，当同时启用 openSearch localSearch 时，将是本地搜索，不会进行网络请求
    localSearch: {
      type: Boolean,
      default: false
    },
    // 字典值
    dict: {
        type: Array,
        default : undefined
    }
  },
  data() {
    return {
      dictDataList: [],
      currentValue: "",
      loading: false, // 加载中
      dictType: undefined,
      ISlabel: "",
      cpPlaceHolder: this.placeholder,
      currentdictParam: {},
      infoData:{}
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  watch: {
    dynamicValue() {
      this.dictDataList = []
      this.$nextTick(() => {
        if(this.labelValue && this.currentValue) {
          let temp = {
            label: this.labelValue,
            value: this.currentValue
          };
          this.dictDataList.push(temp);
        }
      })
    },
    resetSearch(val) {
      if (this.openSearch && val) {
        this.dictDataList = [];
      }
    },
    value() {
    //   if(!this.value){
        //   this.$emit('clearInfo')
    //   }
      console.log('开始改变了 value', this.value)
      if (this.currentValue !== this.value && this.value !== null) {
        this.currentValue = this.value;
        this.test()
      }
    },
    dictUrl() {
      console.log("jinlail")
      if (!this.openSearch) {
        // this.getDictDataAction();
      }
    },
    dictParam() {
      // debugger
      console.log('开始改变了 dictParam', this.dictParam, this.currentdictParam)
      if (!this.isEmpty(this.dictParam) && isEqual(this.currentdictParam, this.dictParam)){
        return
      } else {
        console.log('请求 dictParam')
        this.currentdictParam = this.dictParam
        this.getDictDataAction();
      }
      if (!this.openSearch) {
        console.log('请求 openSearch')
        this.getDictDataAction();
      }
    }
  },
  created() {
    console.log(this.value)
    if (!this.isEmpty(this.value)) {
      this.currentValue = this.value;
    }
    // console.log("value" + this.value)
    if (!this.isEmpty(this.dictParam)) {
      this.currentdictParam = this.dictParam
    }
    if (!this.openSearch || (this.methods === 'post' && !this.autoSearch)) {
      this.getDictDataAction();
    }
    this.test();
  },
  mounted() {
    if (this.openSearch && this.placeholder == '请选择') {
      this.cpPlaceHolder = '请输入后选择'
    }
  },
  methods: {
    clearData() {
        console.log(1)
        this.dictDataList = []
      this.$emit("input", '');
       this.$emit('clearInfo')
    },
    test() {
      if (this.dictDataList.length > 0) {
        if (this.dictType == undefined) {
          this.dictType = typeof this.dictDataList[0]["value"];
        }
        if (this.dictType !== typeof this.currentValue) {
          switch (this.dictType) {
            case "string":
              {
                this.currentValue = this.currentValue.toString();
              }
              break;
            case "number": {
              let aTemp = parseInt(this.currentValue);
              this.currentValue = isNaN(aTemp)
                ? this.isNeedAll
                  ? this.allValue
                  : ""
                : aTemp;
            }
          }
        }
      } else {
        if (this.openSearch && this.labelValue !== "" && !this.autoSearch) {
          let temp = {
            label: this.labelValue,
            value: this.currentValue
          };
          this.dictDataList.push(temp);
        } else if (this.autoSearch) {
          this.remoteMethod(this.currentValue)
        }
      }
    },
    remoteMethod(query) {
      // console.log(query)
      if (query !== "") {
        this.loading = true;
        let requestParma = {
        //   tenantId: "10",//调试时解开
          tenantId: this.userInfo.tenant_id,
          pageIndex: 1,
          pageSize: 40

        };
        if (this.apiForm=="1") {
            requestParma.apiData = {
            apiServeDataProjectId: this.apiForm,
            name: "",
            note: query,
            status: "",
            // tenantId: "10",//调试时解开
            tenantId: this.userInfo.tenant_id,
            type: ""
        };
        } else {
            requestParma.apiServe = {
            apiServeDataProjectId: this.apiForm,
            name: "",
            note: query,
            status: "",
            // tenantId: "10",//调试时解开
            tenantId: this.userInfo.tenant_id,
            type: ""
        };
        }
        this.getDictDataAction(this.openSearch, requestParma);
        this.loading = false;
      } else {
        this.dictDataList = [];
      }
    },
    input(value) {
      console.log(value)
      if(!this.isNeedAll && this.isEmpty(value)){
        return
      }
      this.currentValue = value;
      this.$emit("input", value);
      // console.log('value' + value)
      // console.log("aaaaaaa",this.dictDataList)
      this.dictDataList.forEach(row => {
        if (value == row.value) {
          this.ISlabel = row.label;
        }
      });
      // debugger
      // console.log("ISlabel",this.ISlabel)
      this.$emit("SelectLabel", this.ISlabel);
    },
    loadToView(dictUrl, dictData) {
      this.dictDataList = dictData;
      // console.log('dictData', dictData);
      if (this.cleanIfNoMatch){
        let flag = false
        for (let index in dictData) {
          let item = dictData[index];
          if (item.value === this.currentValue){
            flag = true
          }
        }
        if (!flag) {
          this.input("");
          this.currentValue = ""
        }
      }

    },
    async getDictDataAction(isSearch, query) {
      if (!this.isEmpty(this.dict)) {
        this.loadToView(md5(JSON.stringify(this.dict)), this.dict)
        return
      }

      let result
      isSearch = isSearch == undefined ? false : isSearch;
      query = isSearch == undefined ? "" : query;
      let dictUrl = this.dictUrl;
      let storeKey =
        this.dictUrl +
        (isSearch
          ? JSON.stringify(query)
          : this.methods === "post"
          ? JSON.stringify(this.currentdictParam)
          : "") + JSON.stringify(this.dictProp);
      if(this.isNeedCash) {
        result = getStore({ name: storeKey, type: "session" });
      }
      if (
        !isSearch &&
        result != undefined &&
        result.time > new Date().getTime()
      ) {
        this.loadToView(dictUrl, result.data);
        // console.log("isSearch",isSearch)
      } else {
        // 尝试抢占请求机会
        let loadingKey = storeKey + "loading"

        let loadingFlag = getStore({name:loadingKey, type:'session'})
        // 如果不为空 则说明已经有其他地方正在请求数据，则当前线程等待请求
        if (loadingFlag != undefined || (loadingFlag != undefined && loadingFlag != '') ){
          for(let i = 1; i< 10; i++){
            await this.wait(0.1)
            // 加载历史数据
            let result = getStore({name:storeKey, type:'session'})

            if (result != undefined && result.time > new Date().getTime()) {
              this.loadToView(dictUrl, result.data)
              return
            }
          }
        }
        setStore({
          name: loadingKey,
          content: 'loading',
          type: "session"
        });

        let requestParma = {
          tenantId: this.$store.state.user.tenantId
        }
        let dictData = await getDictData(
          dictUrl,
          isSearch,
          query,
          this.methods,
          Object.assign(requestParma, this.currentdictParam)
        );
        // debugger
        this.infoData= dictData.result.data
        // console.log('下来列表', dictData)
        let realData = [];
        if (this.getResultIsReady(dictData, this.dictProp.data) != undefined) {
          let temp = this.getResultIsReady(dictData, this.dictProp.data);
          for (let index in temp) {
            let item = temp[index];
            if(typeof item == 'object'){
              realData.push({
                label: `${item[this.dictProp.label]}(${item.name})`,
                value: item[this.dictProp.value]
              });
            }else{
              realData.push({label: item, value: item});
            }
          }
        }
        result = {};
        result.data = realData;
        result.time = new Date().getTime() + 5 * 60 * 1000;
        setStore({
          name: storeKey,
          content: result,
          type: "session"
        });
        this.loadToView(dictUrl, result.data);

        // 完成业务后删除flag
        setStore({name:loadingKey, content:'', type:'session'})
        removeStore({name:loadingKey, type:'session'})
      }
      // console.log("zzz",result)
    },
    changeValue(val) {
      console.log("选中的值", val);
      this.$emit('clearInfo')
    //   this.$emit('changeValue', this.circleItem)
      if(this.infoData.length){
         const aaa = this.infoData.find((item)=>{
            return item.id==val
          })
          if(aaa){
              this.$emit('changeInfoData', aaa)
          }
      }
      this.$emit('changeValue', this.circleItem)
    },
    getResultIsReady(dictData, dataProp) {
      let resultDir = dataProp.split(".");
      let temp = dictData;
      resultDir.forEach(element => {
        if (temp[element] !== undefined) {
          temp = temp[element];
        }
      });
      if (temp !== undefined) {
        return temp;
      }
    },
    wait(numberMillis){
      return new Promise(function (resolve) {
        setTimeout(resolve, numberMillis*1000);
      });
    }
  }
};
</script>
<style lang="scss">
.key-value-select{
  position: relative;
  .delete-button{
    position:absolute;
    display:inline-block;
    height:28px;
    width:25px;
    // background:red;
    right: 5px;
    top:0;
    line-height: 28px;
    cursor: pointer;
    color: #C0C4CC;
    text-align: center;
  }
}
</style>
